import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';
import { Mail, Lock, ArrowRight, AlertCircle } from 'lucide-react';

export default function LoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.login(form);
      login(res.data.token, res.data.user);
      toast.success(`Bienvenido, ${res.data.user.name}`);
      const role = res.data.user.role;
      if (role === 'admin') navigate('/admin');
      else if (role === 'supervisor') navigate('/supervisor');
      else navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backgroundImage: 'url(/login-bg.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}>

      {/* Card centrada */}
      <div style={{
        width: '100%',
        maxWidth: 420,
        background: 'rgba(255, 255, 255, 0.97)',
        borderRadius: 20,
        boxShadow: '0 24px 64px rgba(0,0,0,0.35)',
        padding: '40px 36px',
        backdropFilter: 'blur(8px)',
      }}>

        {/* Logo PNG */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img
            src="/logo.png"
            alt="Logo Sistema Talento"
            style={{ width: 190, height: 190, borderRadius: 18, marginBottom: 2 }}
          />
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-error" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
              <AlertCircle size={15} /> {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Correo electrónico</label>
            <div style={{ position: 'relative' }}>
              <Mail size={15} style={{
                position: 'absolute', left: 12, top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--gray-400)', pointerEvents: 'none',
              }} />
              <input
                type="email" className="form-input"
                placeholder="correo@megalabs.com.py"
                style={{ paddingLeft: 36 }}
                value={form.email}
                onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                required autoFocus
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <div style={{ position: 'relative' }}>
              <Lock size={15} style={{
                position: 'absolute', left: 12, top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--gray-400)', pointerEvents: 'none',
              }} />
              <input
                type="password" className="form-input"
                placeholder="••••••••"
                style={{ paddingLeft: 36 }}
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                required
              />
            </div>
          </div>

          <button
            type="submit" className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', marginTop: 8, padding: '11px 16px', fontSize: 15 }}
            disabled={loading}
          >
            {loading ? 'Iniciando sesión…' : <><span>Iniciar sesión</span><ArrowRight size={16} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
